module.exports = __webpack_public_path__ + "static/media/medal-moment.f723c099.svg";